<template>
  <Button
    :transparent="true"
    :light="true"
    size="small"
    class="button"
    @click="$emit('click')"
  >
    <template v-if="showAddToBag">
      Add to bag |
      {{ $filters.toCurrency(price.amount, price.currencyCode) }}
      <template v-if="isOnSale">
        <span class="strike-out">{{
          $filters.toCurrency(originalPrice.amount, originalPrice.currencyCode)
        }}</span>
      </template>
    </template>
    <template v-else> Notify me </template>
  </Button>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "AddToBagTile",
  components: {
    Button,
  },
  props: {
    showAddToBag: {
      type: Boolean,
      default: true,
    },
    price: {
      type: Object,
      required: true,
    },
    originalPrice: {
      type: Object,
      default: null,
    },
  },
  emits: ["click"],
  computed: {
    isOnSale() {
      return (
        parseFloat(this.originalPrice.amount) > parseFloat(this.price.amount)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.strike-out {
  text-decoration: line-through;
}

.button {
  text-align: left;
}
</style>
